import type { ListBuilderList } from '../../../types';
import { createInvoiceColumns } from '../columns';
import {
	ALL_REQUIRED_FIELDS,
	BASE_FILTER_RULES,
	INVOICE_MOBILE_CARD_CONFIG,
} from '../shared';

/**
 * All invoices list - base list showing invoices from the last 90 days
 */
export const allInvoicesList: ListBuilderList = {
	id: 'default-invoices-all',
	cacheTTL: 600000,
	name: 'Last 90D',
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createInvoiceColumns(),
	description: 'Complete list of all invoices with key details',
	defaultSortId: 'column-date-desc',
	requiredFields: ALL_REQUIRED_FIELDS,
	filterRules: BASE_FILTER_RULES,
	mobileCardConfig: INVOICE_MOBILE_CARD_CONFIG,
};
